import {Directive, ElementRef, Input, OnChanges, SimpleChanges} from '@angular/core';

@Directive({selector: '[input-error]'})
export class InputErrorDirective implements OnChanges {

	@Input('input-error') error: string;

	@Input() tinymce_editor: any = null;

	constructor(private eleRef: ElementRef) {

	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.error) {
			this.update_dom();
			if (this.tinymce_editor) {
				this.observe_tinymce_editor_content_change();
			}
		}
	}

	update_dom() {
		if (this.tinymce_editor) {
			const editorBody = this.tinymce_editor.getBody();
			if (!editorBody) {
				return;
			}
			let content = this.tinymce_editor.getContent();
			if (this.error && !content) {
				editorBody.classList.add('error');
				editorBody.setAttribute('data-mce-placeholder', this.error);
			} else {
				editorBody.classList.remove('error');
				editorBody.removeAttribute('data-mce-placeholder');
			}
		}

		let el = this.eleRef.nativeElement;
		if (this.error) {
			el.classList.add('error');
			el.setAttribute('placeholder', this.error);
		} else {
			el.classList.remove('error');
			el.removeAttribute('placeholder');
		}
	}

	observe_tinymce_editor_content_change() {
		if (!this.tinymce_editor) {
			return;
		}
		this.tinymce_editor.on('keyup', () => {
			this.update_dom();
		});
	}
}